var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImg404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 380,
    height: 300,
    rx: 32,
    fill: "url(#bgGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 230,
    rx: 44,
    ry: 12,
    fill: "#A3E44D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 290,
    cy: 230,
    rx: 36,
    ry: 10,
    fill: "#A3E44D",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("text", {
    x: 55,
    y: 175,
    fontFamily: "'Fredoka One', sans-serif",
    fontSize: 88,
    fontWeight: "bold",
    fill: "#fc6767",
    stroke: "#FFB536",
    strokeWidth: 5
  }, "404"), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 140,
    cy: 120,
    rx: 44,
    ry: 30,
    fill: "#33C463",
    stroke: "#2B9144",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172 120C195 128 182 80 148 98",
    stroke: "#2B9144",
    strokeWidth: 4,
    fill: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 131,
    cy: 148,
    rx: 8,
    ry: 3,
    fill: "#33C463"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 155,
    cy: 147,
    rx: 8,
    ry: 3,
    fill: "#33C463"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122,
    cy: 99,
    rx: 20,
    ry: 17,
    fill: "#33C463",
    stroke: "#2B9144",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 122,
    cy: 110,
    rx: 10,
    ry: 6,
    fill: "#68e1fd"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 116,
    cy: 96,
    rx: 2.8,
    ry: 3.2,
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 107Q124 110 128 105",
    stroke: "#FFB536",
    strokeWidth: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114,80 118,79 116,83",
    fill: "#FC6767"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "128,81 132,80 130,84",
    fill: "#FC6767"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138,89 142,89 140,92",
    fill: "#FC6767"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 68,
    rx: 15,
    width: 75,
    height: 32,
    fill: "#FBD53D",
    stroke: "#fc6767",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 192,
    y: 90,
    fontFamily: "Arial",
    fontSize: 22,
    fontWeight: 800,
    fill: "#fc6767"
  }, "Oops!"))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgGradient",
    x1: 0,
    y1: 0,
    x2: 380,
    y2: 300,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#68e1fd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fbd53d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg404);
export default __webpack_public_path__ + "static/media/img404.1c579da75cc75ca59a1e2b6e65cad044.svg";
export { ForwardRef as ReactComponent };